import { useState, useEffect } from "react";
import { BiInfoCircle } from "react-icons/bi";
import InputField from "../../components/input/InputField";
import { useSelector, useDispatch } from "react-redux";
import { createStoreUrl, uploadStoreImageUrl, createWarehouseUrl, generateLogoUrl } from "../../api/endpoints";
import DeliverToggle from "../../components/toggleButton/DeliverToggle";
import { useNavigate } from "react-router-dom";
import { refreshUserToken } from "../../tools/refreshToken";
import { setUser } from "../../slice/webStoreUserSlice";
import Spinner, { ButtonLoader } from "../../components/uxCollections/Loaders";
import ImageCropper from "../../components/imageCropper/ImageCropper";
import { colors } from "./stockManagement/ColorWish";
import { listOfProductCategory } from "./stockManagement/AddStockPage";
import { BsUpload } from "react-icons/bs";
import { X } from "lucide-react";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";

const CreateStoreCard = ({ closeModal }) => {
  const [storeName, setStoreName] = useState("");
  const [storeAddress, setStoreAddress] = useState("");
  const [storeCategory, setStoreCategory] = useState(null);
  const [storeImage, setStoreImage] = useState(null);
  const [croppedStoreImage, setCroppedStoreImage] = useState(null);
  const [isOnlineStoreOnly, setIsOnlineStoreOnly] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [storeImageBuffer, setStoreImageBuffer] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isImageCropperOpen, setIsImageCropperOpen] = useState(false);
  const [openLogoGenerator, setOpenLogoGenerator] = useState(false);
  const [isLogoAiGenerated, setIsLogoAiGenerated] = useState(false);
  const { user } = useSelector((state) => state.webStoreUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (storeName && storeAddress && storeCategory && storeImage) {
      setIsFormValid(true);
      console.log("form is valid");
    } else {
      setIsFormValid(false);
    }
  }, [storeName, storeAddress, storeCategory, storeImage]);

  const handleImageUpload = (e) => {
    const image = e.target.files[0];
    setStoreImageBuffer(image);
    if (image) {
      const reader = new FileReader();
      reader.onload = function (evt) {
        setStoreImage(evt.target.result);
        setIsImageCropperOpen(true);
      };
      reader.readAsDataURL(e.target.files[0]);
    } else {
      console.log("upload filed try again");
    }
  };

  const createStore = async () => {
    let accessToken = localStorage.getItem("accessToken");
    if (isFormValid) {
      setIsLoading(true);
      try {
        let uploadedImage = new FormData();
        uploadedImage.append("storeImage", storeImageBuffer);
        let response = await fetch(uploadStoreImageUrl, {
          method: "POST",
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
          body: uploadedImage,
        });
        console.log(response);
        if (response.ok) {
          console.log(response);
          let { imageUrl } = await response.json();

          let newStore = {
            storeName,
            storeAddress,
            storeCategory,
            storeImage: imageUrl,
            isOnlineStoreOnly,
            rating: 0,
            followers: 0,
            storeOwner: user._id,
          };

          let res2 = await fetch(createStoreUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(newStore),
          });
          if (res2.ok) {
            let data = await res2.json();
            dispatch(setUser(data));
            closeModal(false);
            setIsLoading(false);
          }
        } else if (response.status === 400) {
          refreshUserToken(uploadStoreImageUrl, createStore, navigate);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      uiAlert("form is not valid", "error");
    }
  };

  const createStoreWithAiGeneratedLogo = async () => {
    if (isFormValid) {
      setIsLoading(true);
      let newStore = {
        storeName,
        storeAddress,
        storeCategory,
        storeImage: storeImage,
        isOnlineStoreOnly,
        rating: 0,
        followers: 0,
        storeOwner: user._id,
      };
      try {
        let res = await fetch(createStoreUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify(newStore),
        });
        if (res.ok) {
          let data = await res.json();
          dispatch(setUser(data));
          closeModal(false);
          setIsLoading(false);
        } else if (res.status === 400) {
          refreshUserToken(createStoreUrl, createStoreWithAiGeneratedLogo, navigate);
        } else {
          uiAlert("something went wrong, try again later", "error");
          setIsLoading(false);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    } else {
      uiAlert("form is not valid", "warning");
    }
  };

  return (
    <>
      <div className='storeImageUpload'>
        <InputField
          setValue={setStoreName}
          value={storeName}
          type='text'
          placeholder={"Shop name (24 character max) *"}
          newStyle={JSON.stringify({
            fontSize: "10px",
            height: "50px",
            marginBottom: "14px",
          })}
          maxChar={24}
        />
        <InputField
          id='storeAddressAutoCompleted'
          setValue={setStoreAddress}
          value={storeAddress}
          placeholder={"Shop address  *"}
          type='text'
          newStyle={JSON.stringify({
            fontSize: "10px",
            height: "50px",
            marginBottom: "14px",
          })}
        />

        <div className='category'>
          <select value={storeCategory} onChange={(e) => setStoreCategory(e.target.value)}>
            <option value={""} disabled selected hidden>
              Choose category
            </option>

            {listOfProductCategory.map((category, i) => {
              return (
                <option key={i} value={category}>
                  {category}
                </option>
              );
            })}
          </select>
        </div>

        {/* ww */}
        <div className='no9u7347393'>
          <div className='storeimgageholder'>
            <div className='storeImageDiv21'>
              <img src={storeImage ? storeImage : "https://cdn.dribbble.com/users/101153/screenshots/11104620/warehouse.png"} />
            </div>
            <div>
              {storeName && storeCategory ? (
                <button
                  onClick={() => {
                    setOpenLogoGenerator(true);
                  }}
                  className='btnUploadImagew btnGenImAI'
                >
                  Generate logo wit AI
                </button>
              ) : (
                <button style={{ opacity: "0.6", cursor: "not-allowed" }} className='btnUploadImagew btnGenImAI'>
                  Generate logo wit AI
                </button>
              )}
              <button className='btnUploadImagew'>
                <BsUpload size={16} /> Upload logo{" "}
                <input
                  onChange={(e) => handleImageUpload(e)}
                  name='storeImage'
                  id={"storeImageId"}
                  className='uploadStoreImageIn3'
                  type={"file"}
                  accept='image/*'
                />
              </button>
            </div>
          </div>
          <div onClick={() => setStoreImage(null)} className='removeimage'>
            Remove
          </div>
        </div>

        {/* ww */}

        <div className='onlyOnlineOutletdiv'>
          <p>Online store only</p>
          <DeliverToggle toggleValue={isOnlineStoreOnly} updatetoggle={setIsOnlineStoreOnly} />
        </div>
        {user.store.length < user.maxStore ? (
          <div style={{ color: "rgb(7, 66, 183)" }} className='infomessageCreateStore3e'>
            <BiInfoCircle size={18} /> <span>With a premuim package you can create up tp 10 stores</span>
          </div>
        ) : (
          <div style={{ color: "rgb(182, 73, 15)" }} className='infomessageCreateStore'>
            <BiInfoCircle size={18} /> <span>Maxmuim allowed store has been created</span>
          </div>
        )}
        {user.store.length < user.maxStore && isFormValid ? (
          <div>
            <button onClick={isLogoAiGenerated ? createStoreWithAiGeneratedLogo : createStore} className='CreateStore-warehButton'>
              Create store
            </button>
            {isLoading && <Spinner position={"absolute"} />}
          </div>
        ) : (
          <div>
            <button style={{ pointerEvents: "none", cursor: "not-allowed", opacity: "0.7" }} disabled={true} className='CreateStore-warehButton'>
              Create store
            </button>
          </div>
        )}
      </div>
      {isImageCropperOpen && (
        <ImageCropper
          readImageUrl={storeImage}
          setCroppedImageUrl={setStoreImage}
          setCroppedImageBolb={setStoreImageBuffer}
          closeModal={setIsImageCropperOpen}
        />
      )}

      {openLogoGenerator && (
        <GenerateStoreLogoAI
          closeModal={setOpenLogoGenerator}
          params={{ storeName, storeCategory }}
          updateStoreLogo={setStoreImage}
          updateIsLogoAiGenerated={setIsLogoAiGenerated}
        />
      )}
    </>
  );
};

const warehouseIconUrl = [
  "https://cdn.dribbble.com/users/101153/screenshots/11104620/warehouse.png",
  /*  " https://res.cloudinary.com/ebuka1122/image/upload/v1748124185/allAssets/dcc834eb-811e-4c29-a0fe-88ba2efeccbb.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748124165/allAssets/bddfb738-08cd-4438-8087-c2287cffddfa.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748124096/allAssets/b043a84b-7f06-49d5-b4e3-6659f9421bf3.png", */
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125616/allAssets/003-warehouse-2_z59jsh.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125615/allAssets/001-warehouse_ztuuzw.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125612/allAssets/002-warehouse-1_hifv9n.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125610/allAssets/015-warehouse-storage_vtkncw.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125608/allAssets/013-warehouse-9_ug2whv.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125607/allAssets/014-data-warehouse_b7eflz.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125605/allAssets/012-warehouse-8_zad1xl.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125603/allAssets/010-storage_p3ddh9.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125601/allAssets/009-warehouse-7_wfv7c0.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125599/allAssets/006-warehouse-4_a72esx.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125598/allAssets/008-warehouse-6_yw8z0k.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125596/allAssets/011-distribution_mpx4tt.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125594/allAssets/005-inventory_gb51wb.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125592/allAssets/007-warehouse-5_sdmdhk.png",
  "https://res.cloudinary.com/ebuka1122/image/upload/v1748125591/allAssets/004-warehouse-3_varos4.png",
];
let index = 0;

const CreateWarehouse = ({ closeModal }) => {
  const { user } = useSelector((state) => state.webStoreUser);
  const [warehouseName, setWarehouseName] = useState("");
  const [warehouseAddress, setWarehouseAddress] = useState("");
  /* the warehouse Icon is chosen from the frontend */
  const [warehouseIcon, setWarehouseIcon] = useState(warehouseIconUrl[Math.floor(Math.random() * warehouseIconUrl.length)]); // default icon
  const [isFormValid0, setIsFormValid0] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (warehouseName && warehouseAddress && warehouseIcon) {
      setIsFormValid0(true);
      console.log("form is valid");
    } else {
      setIsFormValid0(false);
    }
  }, [warehouseName, warehouseAddress, warehouseIcon]);

  console.log(user.maxWarehouse !== 0);
  console.log(user.warehouse.length < user.maxWarehouse);

  const createWarehouse = async () => {
    let accessToken = localStorage.getItem("accessToken");
    if (isFormValid0) {
      let newWarehouse = {
        warehouseName,
        warehouseAddress,
        warehouseIcon,
      };
      try {
        let res = await fetch(createWarehouseUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(newWarehouse),
        });
        if (res.ok) {
          let data = await res.json();
          dispatch(setUser(data));
          closeModal(false);
        } else if (res.status === 400) {
          refreshUserToken(createWarehouseUrl, createWarehouse, navigate);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      uiAlert("form is not valid", "warning");
    }
  };

  const changeIcon = () => {
    console.log(index);

    if (index >= warehouseIconUrl.length) {
      index = 0; // Reset index if it exceeds the length of the array
    }

    let randomIcon = warehouseIconUrl[index];
    setWarehouseIcon(randomIcon);
    console.log("icon changed to ", randomIcon);
    index++;
  };

  return (
    <>
      <div className='storeImageUpload'>
        <div style={{ marginBottom: "20px" }}>
          <div className='storeimgageholder'>
            <div className='storeImageDiv21'>
              {" "}
              <img src={warehouseIcon} />
            </div>
            <button onClick={changeIcon} className='btnUploadImagew'>
              Change icon
            </button>
          </div>
        </div>

        <InputField
          setValue={setWarehouseName}
          value={warehouseName}
          placeholder={"Warehouse name  *"}
          newStyle={JSON.stringify({
            fontSize: "10px",
            height: "50px",
            marginBottom: "14px",
          })}
        />
        <InputField
          setValue={setWarehouseAddress}
          value={warehouseAddress}
          placeholder={"Warehouse address  *"}
          newStyle={JSON.stringify({
            fontSize: "10px",
            height: "50px",
            marginBottom: "14px",
          })}
        />
        {/*  <div className='infomessageCreateStore'>
          <BiInfoCircle /> <span>With a premuim package you can create up to 5 warehouses</span>
        </div> */}

        {user.warehouse.length < user.maxWarehouse ? (
          <div style={{ color: "rgb(7, 66, 183)" }} className='infomessageCreateStore3e'>
            <BiInfoCircle /> <span>With a premuim package you can create up to 5 warehouses</span>
          </div>
        ) : (
          <div style={{ color: "rgb(182, 73, 15)" }} className='infomessageCreateStore'>
            <BiInfoCircle /> <span>Maxmuim allowed warehouse has been created</span>
          </div>
        )}
        {user.maxWarehouse !== 0 && user.warehouse.length < user.maxWarehouse && isFormValid0 ? (
          <div>
            <button onClick={createWarehouse} className='CreateStore-warehButton'>
              Create warehouse
            </button>
          </div>
        ) : (
          <div>
            <button style={{ pointerEvents: "none", cursor: "not-allowed", opacity: "0.7" }} disabled={true} className='CreateStore-warehButton'>
              Create warehouse
            </button>
          </div>
        )}
      </div>
    </>
  );
};

const CreateStore = ({ closeModal }) => {
  const [store, setStore] = useState(true);
  const handleModal = (e) => {
    if (e.target === e.currentTarget) {
      closeModal(false);
    }
  };

  return (
    <>
      <div onClick={(e) => handleModal(e)} className='createStore'>
        <div className='createStoreWrapper'>
          <h4>Create Store or Warehouse </h4>
          <div className='toggleCreateStore'>
            <div onClick={() => setStore(true)} className={store ? "activeTabC" : ""}>
              Store
            </div>
            <div className={!store ? "activeTabC" : ""} onClick={() => setStore(false)}>
              Warehouse
            </div>
          </div>
          {store ? <CreateStoreCard closeModal={closeModal} /> : <CreateWarehouse closeModal={closeModal} />}
          <span onClick={() => closeModal(false)} className='closeCreateStore'>
            <X size={20} />
          </span>
        </div>
      </div>
    </>
  );
};

export default CreateStore;

const GenerateStoreLogoAI = ({ closeModal, params, updateStoreLogo, updateIsLogoAiGenerated }) => {
  const [defautParams, setDefautParams] = useState({
    slogan: "",
    description: "",
    LogoColor: "black",
  });
  const [generatedLogo, setGeneratedLogo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  /* check if params are entered and enable isFOrmValid to true */

  /* https://res.cloudinary.com/ebuka1122/image/upload/v1710435402/Ihub-store-images/tgutpspkycqk4ljmafve.jpg */
  /* https://api.cloudinary.com/v1_1/ebuka1122/image/upload */
  useEffect(() => {
    if (defautParams.slogan && defautParams.description) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [defautParams]);

  const generateLogoFun = async () => {
    setIsLoading(true);
    let payload = {
      imageText: defautParams.slogan,
      LogoColor: defautParams.LogoColor,
      storeName: params.storeName,
      category: params.storeCategory,
    };

    try {
      let response = await fetch(generateLogoUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        let { logoUrl } = await response.json();

        setGeneratedLogo(logoUrl);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const useGeneratedLogo = () => {
    updateStoreLogo(generatedLogo);
    updateIsLogoAiGenerated(true);
    closeModal(false);
  };

  return (
    <>
      <div className='createStore'>
        <div className='formToGenIm'>
          <div className='logoDisplay33'>
            <img src={generatedLogo ? generatedLogo : "https://cdn.dribbble.com/users/101153/screenshots/11104620/warehouse.png"} />
          </div>
          <h3 className='grnTitlt33'>Complete form to generate logo </h3>
          <div className='inputFieldAnimated passwordIn poxdrr'>
            <input
              value={defautParams.slogan}
              onChange={(e) => setDefautParams({ ...defautParams, slogan: e.target.value })}
              style={{
                paddingLeft: "20px",
                paddingTop: "0",
                width: "100%",
              }}
              type={"text"}
              required={true}
              maxLength={15}
            />
            <p
              style={{
                top: "14px",
                left: "20px",
              }}
            >
              Store Slogan (10 characters max)*
            </p>
          </div>
          <div className='inputFieldAnimated passwordIn poxdrr'>
            <input
              className='smallDes2736'
              value={defautParams.description}
              onChange={(e) => setDefautParams({ ...defautParams, description: e.target.value })}
              style={{
                paddingLeft: "20px",
                paddingTop: "0",
                width: "100%",
              }}
              type={"text"}
              required={true}
            />
            <p
              style={{
                top: "14px",
                left: "20px",
              }}
            >
              Description of store activity (80 char max) *
            </p>
          </div>

          <div className='selectColor122'>
            <span style={{ backgroundColor: defautParams.LogoColor }}></span>
            <div>
              <select onChange={(e) => setDefautParams({ ...defautParams, LogoColor: e.target.value })}>
                <option value='' disabled selected hidden>
                  Logo color
                </option>
                {colors.map((color, i) => {
                  return (
                    <option key={i} className='flexColorDiv22'>
                      <span style={{ backgroundColor: `${color.name}` }}></span>
                      <p> {color.name} </p>
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          {generatedLogo ? (
            <button onClick={useGeneratedLogo} className='genBTnLog'>
              {" "}
              Use logo as store logo{" "}
            </button>
          ) : isFormValid ? (
            isLoading ? (
              <button style={{ opacity: "0.7" }} className='genBTnLog'>
                {" "}
                <ButtonLoader />{" "}
              </button>
            ) : (
              <button onClick={generateLogoFun} className='genBTnLog'>
                {" "}
                Generate logo with AI{" "}
              </button>
            )
          ) : (
            <button style={{ opacity: "0.6", cursor: "not-allowed" }} className='genBTnLog'>
              {" "}
              Generate logo with AI{" "}
            </button>
          )}

          {
            <button style={{ opacity: isLoading ? "0.7" : "" }} onClick={() => !isLoading && closeModal(false)} className='returnUploadLof'>
              {" "}
              Upload my logo instead{" "}
            </button>
          }
        </div>
      </div>
    </>
  );
};
